var map = {
	"./1.png": 1219,
	"./2.png": 1220,
	"./3.png": 1221,
	"./4.png": 1222,
	"./5.png": 1223,
	"./6.png": 1224,
	"./7.png": 1225,
	"./8.png": 1226,
	"./avatar/1.png": 643,
	"./avatar/2.png": 644,
	"./avatar/3.png": 645,
	"./avatar/4.png": 646,
	"./avatar/5.png": 647,
	"./avatar/6.png": 648,
	"./avatar/7.png": 649,
	"./avatar/8.png": 650,
	"./ei_board.png": 525,
	"./ei_example.png": 527,
	"./ei_step.png": 526,
	"./scenario.png": 164
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 642;